<!-- Navbar Section -->
<nav class="navbar navbar-light bg-light app-header border-bottom">
  <div class="container d-flex justify-content-between align-items-center">
    <a href="https://gooddogkh.com" target="_blank" rel="noopener" class="navbar-brand">
      <img
        src="assets/img/brand/coco-pet-resort-long.png"
        class="img-fluid"
        style="max-height: 50px; width: auto;"
        title="CoCo Pet Logo"
      />
    </a>

    <ul class="navbar-nav flex-row align-items-center">
      <li *ngFor="let language of supportedLanguages" class="nav-item ms-2">
        <a class="nav-link p-0" (click)="changeLanguage(language)" style="cursor: pointer;">
          <img
            src="assets/img/flags/4x3/{{language}}.svg"
            alt="Flag"
            style="width: 30px; height: auto;"
          />
        </a>
      </li>
    </ul>
  </div>
</nav>

<div class="bg-light py-3 py-md-5">
  <c-container>
    <c-row class="justify-content-center">
      <c-col xs="12" md="10" lg="8">
        <c-card class="shadow-sm">
          <c-card-body class="p-3 p-md-4">

            <h1 class="h3">{{ "PUBLIC_QR_CODE.TITLE" | translate }}</h1>
            <p class="text-medium-emphasis mb-4">{{ "PUBLIC_QR_CODE.SUB_TITLE" | translate }}</p>

            <c-row>
              <c-col>
                <div *ngIf="isPublicQRCodeDetailLoaded; else loading">

                  <!-- Message Section (Null Protected) -->
                  <div
                    *ngIf="publicQRCodeDetail?.message"
                    class="mb-4 p-3 bg-white rounded border"
                    [innerHTML]='getSafeContent(publicQRCodeDetail["message"])'>
                  </div>

                  <!-- Pet Image (Responsive) -->
                  <div *ngIf="publicQRCodeDetail?.pet_image" class="text-center mb-4">
                    <img
                      [src]="this.petImageUrl"
                      alt="Pet image"
                      class="img-fluid rounded shadow-sm"
                      style="max-width: 400px; width: 100%; height: auto;"
                    />
                  </div>

                  <!-- Details List with Space after Colon -->
                  <div class="details-list">
                    <p *ngIf="publicQRCodeDetail?.pet_name" class="card-text border-bottom pb-2">
                      <strong>{{ "PUBLIC_QR_CODE.PET_NAME" | translate }}:</strong>&nbsp;
                      <span class="ms-1">{{ publicQRCodeDetail.pet_name }}</span>
                    </p>

                    <p *ngIf="publicQRCodeDetail?.pet_gender" class="card-text border-bottom pb-2">
                      <strong>{{ "PUBLIC_QR_CODE.PET_GENDER" | translate }}:</strong>&nbsp;
                      <span class="ms-1">{{ publicQRCodeDetail.pet_gender }}</span>
                    </p>

                    <p *ngIf="publicQRCodeDetail?.owner_first_name" class="card-text border-bottom pb-2">
                      <strong>{{ "PUBLIC_QR_CODE.OWNER_FIRST_NAME" | translate }}:</strong>&nbsp;
                      <span class="ms-1">{{ publicQRCodeDetail.owner_first_name }} {{ publicQRCodeDetail.owner_last_name }}</span>
                    </p>

                    <p *ngIf="publicQRCodeDetail?.owner_phone" class="card-text border-bottom pb-2">
                      <strong>{{ "PUBLIC_QR_CODE.OWNER_PHONE" | translate }}:</strong>&nbsp;
                      <span class="ms-1">
                        <a href="tel:{{publicQRCodeDetail.owner_phone}}" class="text-decoration-none">
                           {{ publicQRCodeDetail.owner_phone }}
                        </a>
                      </span>
                    </p>

                    <p *ngIf="publicQRCodeDetail?.owner_email" class="card-text border-bottom pb-2">
                      <strong>{{ "PUBLIC_QR_CODE.OWNER_EMAIL" | translate }}:</strong>&nbsp;
                      <span class="ms-1 text-break">{{ publicQRCodeDetail.owner_email }}</span>
                    </p>

                    <p *ngIf="publicQRCodeDetail?.owner_emergency_contact" class="card-text">
                      <strong>{{ "PUBLIC_QR_CODE.OWNER_EMERGENCY_CONTACT" | translate }}:</strong>&nbsp;
                      <span class="ms-1">{{ publicQRCodeDetail.owner_emergency_contact }}</span>
                    </p>
                  </div>
                </div>

                <!-- Loading Spinner -->
                <ng-template #loading>
                   <div class="text-center p-5">
                     <c-spinner color="primary"></c-spinner>
                   </div>
                </ng-template>

              </c-col>
            </c-row>

          </c-card-body>
        </c-card>
      </c-col>
    </c-row>
  </c-container>
</div>
